import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import * as ReactDOM from 'react-dom';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Button, Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import Loader from '../../../components/base/Loader/Loader';
import Grid from '../../../components/base/Grid/Grid';
import Switches from '../../../components/fields/Switches/Switches';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import SettingsDTO from '../../../dto/SettingsDTO';
import { loadSettingEnumLimited } from '../actions';
import { responseLogWithNotification } from '../../../utils/utils';

export default function SettingsPageForm(props) {
  const {
    onHide,
    handleCreate = () => {},
  } = props;
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const close = () => {
    onHide();
  };
  const namePrefix = 'scopes';
  const DTO = new SettingsDTO();
  const attributes = DTO.getAttributesByName();
  const [scopes, setScopes] = useState([]);

  const {
    control, setValue, getValues,
  } = useForm({
    defaultValues: {
      scopes: [],
      is_active: true,
      is_test: true,
    },
  });

  const loadData = () => {
    dispatch(loadSettingEnumLimited()).catch(responseLogWithNotification).then(response => {
      const allScopesEnum = response || [];
      const result = allScopesEnum.reduce((acc, item) => {
        acc[item.value] = false;
        return acc;
      }, {}) || {};
      setValue(namePrefix, result);
      const scopesList = response?.map(item => ({ name: item.label, key: item.value, enable: scopes.includes(item.value) })) || [];
      setScopes(scopesList);
    });
  };

  useEffect(() => { loadData(); }, []);

  const columns = [
    {
      dataField: 'name',
      text: 'Передаваемая информация',
      headerClassName: 'name-column',
      disableSort: true,
    },
    {
      dataField: 'enable',
      text: 'Активен',
      disableSort: true,
      formatter: (_, item) => (
        <FieldDTOWithCol
          control={control}
          type="text"
          component={Switches}
          dtoObject={{
            name: `${namePrefix}.${item?.key}`,
            type: String,
            validators: {},
            labelKey: 'settings.key',
          }}
          variant="material"
          withLabel={false}
        />
      ),
    },
  ];

  return ReactDOM.createPortal(
    <div className="setting-view-page">
      <div className="setting-view-page-header">
        <div className="breadcrumbs">
          <span className="breadcrumbs-prev" onClick={close}>Создание нового API</span>
          <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
          <span className="breadcrumbs-current"> Настройка API</span>
        </div>
        <div className="close-button" onClick={close}>
          <Icons width={24} height={24} customIcon icon="close" />
        </div>
      </div>
      <div className="setting-view-wrapper">
        <div className="setting-box">
          <div className="setting-box-title">
            Заполните информацию
          </div>
          <div className="setting-box-form">
            <div className="setting-action-content-info">
              <div className="setting-action-content-info-icon">
                <Icons width={24} height={24} customIcon icon="env" />
              </div>
              <div className="setting-action-content-info-text">
                <div className="setting-action-content-info-text-title">
                  Окружение
                </div>
                {formatMessage({ id: 'envirament.info' })}
              </div>
            </div>
            <div className="hr-row" />
            <Row className="row-cols-1">
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.name}
                variant="material"
              />
            </Row>
            <div className="setting-box-title">Ограничения</div>
            <div className="setting-box-content">
              <div className="grid-wrapper">
                <Grid emptyText="" data={scopes} columns={columns} name="profile-list" />
              </div>
            </div>
          </div>
          <div className="setting-box-footer">
            <Button onClick={onHide} variant="secondary">Отменить</Button>
            <Button onClick={() => handleCreate(getValues())}>Сохранить</Button>
          </div>
        </div>
      </div>
    </div>,
    document.getElementById('app-content'),
  );
}
